import { AppSession } from '@prisma/client'
import { Tag } from 'antd'
import { CSSProperties } from 'react'

const tagStyle: CSSProperties = { width: '90px', textAlign: 'center' }

export const StatusTag: React.FC<{ appSession: AppSession }> = ({
  appSession,
}) => {
  switch (appSession.status) {
    case 'ACTIVE':
      return (
        <Tag style={{ ...tagStyle }} color="green-inverse">
          Active
        </Tag>
      )
    case 'TO_ONBOARD':
      return (
        <Tag style={{ ...tagStyle }} color="blue-inverse">
          To Onboard
        </Tag>
      )
    default:
      return (
        <Tag style={{ ...tagStyle }} color="grey">
          Disabled
        </Tag>
      )
  }
}
